import styled from 'styled-components';
import { buttonBase, getIconButtonSize, getToggleButtonAppearance, iconButtonBase } from 'modules/buttonStyles';
export const IconToggleButtonContainer = styled.button `
  ${buttonBase}
  ${iconButtonBase}

  ${(props) => getToggleButtonAppearance(props.$appearance, props.$toggled)};
  ${(props) => getIconButtonSize(props.size)};
`;
